import createElement from '../../utils/create_element';
import Episode from './episode';

export default class EpisodePanel {
  constructor({ data } = {}) {
    this.cache = {};
    this._data = data;
  }

  data() {
    return this._data;
  }

  episodePanel() {
    return this._episodePanel;
  }

  episodeList() {
    return this._episodeList;
  }

  setContent(content) {
    this.episodeList().innerHTML = content;
  }

  setSeasonName(name) {
    this._header.querySelector('b').innerHTML = name;
  }

  addEpisode(episode) {
    this.episodeList().appendChild(episode);
  }

  setScrollPosition(position) {
    this.episodeList().scrollTop = position;
  }

  show() {
    this.episodePanel().classList.add('active');
  }

  hide() {
    this.episodePanel().classList.remove('active');
  }

  createCloseButton() {
    const button = createElement(`
      <button class="episode-chooser-episode-button-close">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16"><defs><filter id="a" width="105.9%" height="106.7%" x="-3%" y="-3.3%" filterUnits="objectBoundingBox"><feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/><feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"/><feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0.117647059 0 0 0 0 0.117647059 0 0 0 0 0.117647059 0 0 0 0.1 0"/><feMerge><feMergeNode in="shadowMatrixOuter1"/><feMergeNode in="SourceGraphic"/></feMerge></filter><path id="b" d="M4.864 7h8.134a1 1 0 110 2H4.865l2.89 3.344a1 1 0 01-1.513 1.308L2.487 9.308a1.998 1.998 0 010-2.616l3.755-4.346a1 1 0 111.513 1.307L4.864 7z"/></defs><g filter="url(#a)" transform="translate(-17 -16)" fill="none" fill-rule="evenodd"><g transform="translate(17 16)"><path fill="none" d="M0 0h16v16H0z"/><mask id="c" fill="#fff"><use xlink:href="#b"/></mask><use fill="#333" fill-rule="nonzero" xlink:href="#b"/><g fill="#333" mask="url(#c)"><path d="M.667.667h14.667v14.667H.667z"/></g></g></g></svg>
      </button>
    `);
    button.onclick = () => {
      this.hide();
    };

    return button;
  }

  createHeader() {
    return createElement(`
      <div class="episode-chooser-episode-header">
        <b></b>
      </div>
    `);
  }

  createEpisodeList() {
    return createElement(`<ul class="episode-chooser-episode-list"></ul>`);
  }

  dom() {
    this._episodePanel = createElement(`<div class="episode-chooser-episode"></div>`);
    this._closeButton = this.createCloseButton();
    this._header = this.createHeader();
    this._episodeList = this.createEpisodeList();

    this._header.prepend(this._closeButton);
    this._episodePanel.append(this._header);
    this._episodePanel.append(this._episodeList);

    return this._episodePanel;
  }

  fetchEpisodesFromSeason(season_id) {
    return new Promise((resolve, reject) => {
      return fetch(`/seasons/${season_id}`)
        .then(response => response.json())
        .then(data => data.season)
        .then(resolve)
        .catch(reject);
    });
  }

  showEpisodeFromSeason(season) {
    this.setSeasonName(season.name);
    this.setScrollPosition(0);
    this.setContent('');

    if (this.cache[season.id]) {
      this.setEpisodes(this.cache[season.id]);
    } else {
      this.fetchEpisodesFromSeason(season.id).then((episodes) => {
        this.cache[season.id] = episodes;
        this.setEpisodes(episodes);
      });
    }
  }

  setEpisodes(episodes) {
    let isCurrentEpisode = false;

    episodes.forEach((episode) => {
      if (episode.title === this.data().videoTitle()) {
        isCurrentEpisode = true;
      }
      const child = new Episode({ episode, isCurrentEpisode, data: this.data() });
      this.addEpisode(child.dom());
    });
    this.show();
    this.shouldScrollToCurrentEpisode(isCurrentEpisode);
  }

  scrollToCurrentEpisode() {
    const current_episode = document.querySelector('.episode-chooser-episode-list-item.current');
    const parent_element = current_episode.parentElement;
    const position = current_episode.getBoundingClientRect().y - parent_element.getBoundingClientRect().y;
    this.setScrollPosition(position);
  }

  shouldScrollToCurrentEpisode(value) {
    if (value === true) {
      this.scrollToCurrentEpisode();
    } else {
      this.setScrollPosition(0);
    }
  }
}
